import { Option as SelectOption } from '@node-space/storybook-components/dist/Select'

export const currencyOptions: SelectOption[] = [
  { label: 'Australian Dollar', value: 'AUD' },
  { label: 'Euro', value: 'EUR' },
  { label: 'British Pound Sterling', value: 'GBP' },
  { label: 'Mexican Peso', value: 'MXN' },
  { label: 'United States Dollar', value: 'USD' },
]
